import {
  BackgroundVariant,
  ResourceRowProps,
  ResourcesRow,
  Section,
} from "@ecologi/react-components";
import { ProjectInsightsHeader } from "@ecologi/react-components/src";
import { ProjectInsightsLocationsSection } from "@ecologi/react-components/src/ProjectInsightsPageComponents";
import {
  ProjectLocationsMap,
  ProjectLocationsMapProps,
} from "@ecologi/react-components/src/ProjectLocationsMap";
import {
  ProjectUpdatesCarousel,
  ProjectUpdatesCarouselProps,
} from "@ecologi/react-components/src/ProjectUpdatesCarousel";
import {
  SupportedProjectsFilter,
  SupportedProjectsProps,
} from "@ecologi/react-components/src/SupportedProjectsFilter";
import { Typography } from "@ecologi/react-components/src/Typography";
import { Wrapper } from "@ecologi/react-components/src/Wrapper";
import styled from "@emotion/styled";
import React from "react";

const ContentWrapper = styled.div`
  background-color: ${BackgroundVariant.WHITE};
`;

const EmptyStateWrapper = styled(Wrapper)`
  text-align: center;
  padding-top: 64px;
  padding-bottom: 80px;
`;

export interface ProjectInsightsSectionsProps {
  hasSupportedProjects: boolean;
  projectLocationsMap: ProjectLocationsMapProps;
  supportedProjects: SupportedProjectsProps;
  projectTransparency: ResourceRowProps["data"];
  projectUpdates: ProjectUpdatesCarouselProps["data"];
}

export const ProjectInsightsBody = ({
  hasSupportedProjects,
  projectLocationsMap,
  supportedProjects,
  projectTransparency,
  projectUpdates,
}: ProjectInsightsSectionsProps) => {
  return (
    <ContentWrapper>
      <ProjectInsightsHeader />
      {hasSupportedProjects ? (
        <>
          <Section.Outer
            backgroundVariant={BackgroundVariant.WHITE}
            paddingTopOverride="0"
          >
            <Section.Heading
              title="Updates from your projects"
              marginBottomOverride="42px"
            />
            <Wrapper isExtraLarge>
              <ProjectUpdatesCarousel data={projectUpdates} />
            </Wrapper>
          </Section.Outer>

          <Section.Outer backgroundVariant={BackgroundVariant.GREY}>
            <Section.Heading
              title="Your project locations"
              subtitle="Your projects are situated across the globe"
              marginBottomOverride="20px"
            />
            <Wrapper isExtraLarge>
              <ProjectInsightsLocationsSection>
                <ProjectLocationsMap {...projectLocationsMap} />
              </ProjectInsightsLocationsSection>
            </Wrapper>
          </Section.Outer>

          <Section.Outer backgroundVariant={BackgroundVariant.WHITE}>
            <Section.Title use="sectionTitle">
              Your carbon avoidance projects
            </Section.Title>
            <Wrapper isExtraLarge>
              <SupportedProjectsFilter {...supportedProjects} />
            </Wrapper>
          </Section.Outer>
        </>
      ) : (
        <EmptyStateWrapper isExtraSmall>
          <Typography use="body1">
            You haven't supported any specific projects yet, once you have your
            projects will appear here.
          </Typography>
        </EmptyStateWrapper>
      )}
      <ResourcesRow
        data={projectTransparency}
        sectionTitle="Project transparency"
        sectionSubtitle="See the evidence of our impact"
        backgroundVariant={BackgroundVariant.GREY}
      />
    </ContentWrapper>
  );
};
